import Checkbox from 'components/inputs/Checkbox'
import DeleteUserModal from './DeleteUserModal'
import { useAuth } from 'contexts/AuthContext'
import EditUserModal from './EditUserModal'
import Button from 'components/Button'
import TopBar from 'components/Topbar'
import { useState } from 'react'
import './index.scss'

const Settings = () => {
  const { user, refreshUserData } = useAuth()
  const [modal, setModal] = useState<string>('')

  return (
    <>
      {modal === 'edit' && user && <EditUserModal onClose={() => setModal('')} body={user} onReload={refreshUserData} />}
      {modal === 'delete' && user && <DeleteUserModal onClose={() => setModal('')} />}
      <div className='settings'>
        <TopBar isSticky theme='dark' title='Ustawienia' />
        <div className="settings__content">
          <div className="myInput">
            <label>Nazwa</label>
            <div className="empty">
              {user?.name !== null ? user?.name : 'Brak'}
            </div>
          </div>
          <div className="myInput">
            <label>Data urodzenia</label>
            <div className="empty">
              {user?.birth !== null ? user?.birth : 'Brak'}
            </div>
          </div>
          <div className="myInput">
            <label>Email</label>
            <div className="empty">
              {user?.email !== null ? user?.email : 'Brak'}
            </div>
          </div>
          <Checkbox
            disabled
            content='Zgody marketingowe'
            checked={!!user?.consent_advertising}
            onChanged={() => { }}
          />
          <Checkbox
            disabled
            content='Ukryj adres email'
            checked={!!user?.is_email_hidden}
            onChanged={() => { }}
          />
          <div className="buttons">
            <Button text='Edytuj' icon='edit' action={() => setModal('edit')} type='secondary' />
            <Button text='Usuń konto' icon='trash' action={() => setModal('delete')} type='empty' />
          </div>
        </div>
      </div>
    </>)
}

export default Settings